import { Infobox } from 'app/components/Infobox'
import { MaterialInput } from 'app/components/material'
import MaterialNumber from 'app/components/material/MaterialNumber';
import { IQuestion, IQuestionsGroupProps, QuestionsGroup } from 'app/components/questions/base'
import { store } from 'app/redux/App/store'
import * as _ from 'lodash'
import * as React from 'react'
import { Col, Row } from 'react-bootstrap'

type itemFootnoteFormatter = (e: any) => any
type FootnoteFormatter = () => string | JSX.Element

interface IDoubleQuestionProps extends IQuestionsGroupProps {
  headerDescription?: string
  question1: IQuestion
  question2: IQuestion
  option?: {
    question1: IQuestion
    question2: IQuestion
    callToAction: string
    callToActionTooltip?: string
    itemFootnoteFormatter?: itemFootnoteFormatter
  }
  footer?: string | FootnoteFormatter
  itemFootnoteFormatter?: itemFootnoteFormatter
}

interface IDoubleQuestionState {
  optionalInputIsOpen: boolean
  mainValue1: any
  optionValue1: any
  mainValue2: any
  optionValue2: any
}

class DoubleQuestion extends QuestionsGroup<IDoubleQuestionProps, IDoubleQuestionState> {
  state = {
    optionalInputIsOpen: false,
    mainValue1: undefined,
    optionValue1: undefined,
    mainValue2: undefined,
    optionValue2: undefined
  }

  componentWillMount() {
    const { option } = this.props
    this.convertMainValue1(this.getValueForQuestion(this.props.question1.name))
    this.convertMainValue2(this.getValueForQuestion(this.props.question2.name))

    if (typeof option === 'object') {
      const optionValue1 = this.getValueForQuestion(option.question1.name)
      const hasName1Value = optionValue1 !== null && optionValue1 !== undefined && optionValue1 !== ''
      this.convertOptionValue1(optionValue1)

      const optionValue2 = this.getValueForQuestion(option.question2.name)
      const hasName2Value = optionValue2 !== null && optionValue2 !== undefined && optionValue2 !== ''
      this.convertOptionValue2(optionValue2)

      const optionalInputIsOpen = hasName1Value || hasName2Value

      this.setState({ optionalInputIsOpen })
    }
  }

  toggleOptionalInputIsOpen() {
    this.setState({ optionalInputIsOpen: !this.state.optionalInputIsOpen })
  }

  convertMainValue1(e: any) {
    if (this.props.itemFootnoteFormatter) {
      const mainValue1 = this.props.itemFootnoteFormatter(e)
      this.setState({ mainValue1 })
    }
  }

  convertOptionValue1(e: any) {
    if (this.props.option.itemFootnoteFormatter) {
      const optionValue1 = this.props.option.itemFootnoteFormatter(e)
      this.setState({ optionValue1 })
    }
  }

  convertMainValue2(e: any) {
    if (this.props.itemFootnoteFormatter) {
      const mainValue2 = this.props.itemFootnoteFormatter(e)
      this.setState({ mainValue2 })
    }
  }

  convertOptionValue2(e: any) {
    if (this.props.option.itemFootnoteFormatter) {
      const optionValue2 = this.props.option.itemFootnoteFormatter(e)
      this.setState({ optionValue2 })
    }
  }

  renderFooter() {
    if (!this.props.footer) { return null }
    const footer = _.isFunction(this.props.footer) ? this.props.footer() : this.props.footer
    return (
      <p className="questionFooter">{footer}</p>
    )
  }

  render() {
    const Input1 = (this.props.option.question1.numberMode || this.props.option.question1.formattedNumberMode) ? MaterialNumber : MaterialInput
    const Input2 = (this.props.option.question2.numberMode || this.props.option.question2.formattedNumberMode) ? MaterialNumber : MaterialInput
    const profile = store.getState().Profile.getNative('info')

    // sometimes the second question is for a spouse (which might not exist)
    let question2Applies = true
    if (this.props.question2.needsSpouse) {
      question2Applies = profile.spouseIsValid()
    }

    // sometimes the second question is for a spouse (which might not exist)
    let optionalQuestion2Applies = true
    if (this.props.option.question2.needsSpouse) {
      optionalQuestion2Applies = profile.spouseIsValid()
    }

    return (
      <section>
        <header className="animated fadeIn">
          {this.props.icon ?
            <i className={this.props.icon} /> : null
          }
          <span>{this.props.header}</span>
        </header>
        <article className="animated fadeIn delayed">
          {this.props.headerDescription ?
            <h4 className="lead">{this.props.headerDescription}</h4> : null
          }

          <Row>
            <Col md={6}>
              <Input1 placeholder={this.props.question1.placeholder}
                name={this.props.question1.name}
                defaultValue={this.getValueForQuestion(this.props.question1.name)}
                type={this.props.question1.type}
                numberMode={this.props.question1.numberMode}
                formattedNumberMode={this.props.question1.formattedNumberMode}
                onChange={(e) => this.convertMainValue1(e.target.value)}
                autoFocus
                required />

              {this.props.itemFootnoteFormatter &&
                <div className="question-footnote">{this.state.mainValue1}</div>
              }

              {this.props.question1.unit ?
                <input type="hidden"
                  name={`${this.props.question1.name}Units`}
                  value={this.props.question1.unit} />
                : null
              }
            </Col>
            {question2Applies && <Col md={6}>
              <Input2 placeholder={this.props.question2.placeholder}
                name={this.props.question2.name}
                defaultValue={this.getValueForQuestion(this.props.question2.name)}
                type={this.props.question2.type}
                numberMode={this.props.question2.numberMode}
                formattedNumberMode={this.props.question2.formattedNumberMode}
                onChange={(e) => this.convertMainValue2(e.target.value)}
                required />

              {this.props.itemFootnoteFormatter &&
                <div className="question-footnote">{this.state.mainValue2}</div>
              }

              {this.props.question2.unit ?
                <input type="hidden"
                  name={`${this.props.question2.name}Units`}
                  value={this.props.question2.unit} />
                : null
              }
            </Col>}
          </Row>

          <label className="cta-margin-y">
            <input type="radio" checked={this.state.optionalInputIsOpen} onClick={() => this.toggleOptionalInputIsOpen()} />
            <span>{this.props.option.callToAction}</span>
            {!!this.props.option.callToActionTooltip && <Infobox placement="left">{this.props.option.callToActionTooltip}</Infobox>}
          </label>

        </article>

        {this.state.optionalInputIsOpen ?
          <section className="animated fadeIn">
            <Row>
              <Col md={6}>
                <Input1 placeholder={this.props.option.question1.placeholder}
                  name={this.props.option.question1.name}
                  defaultValue={this.getValueForQuestion(this.props.option.question1.name)}
                  type={this.props.option.question1.type}
                  numberMode={this.props.option.question1.numberMode}
                  formattedNumberMode={this.props.question1.formattedNumberMode}
                  onChange={(e) => this.convertOptionValue1(e.target.value)}
                  autoFocus
                  required />

                {this.props.itemFootnoteFormatter &&
                  <div className="question-footnote">{this.state.optionValue1}</div>
                }

                {this.props.option.question1.unit ?
                  <input type="hidden"
                    name={`${this.props.option.question1.name}Units`}
                    value={this.props.option.question1.unit} />
                  : null
                }
              </Col>
              {optionalQuestion2Applies && <Col md={6}>
                <Input2 placeholder={this.props.option.question2.placeholder}
                  name={this.props.option.question2.name}
                  defaultValue={this.getValueForQuestion(this.props.option.question2.name)}
                  type={this.props.option.question2.type}
                  numberMode={this.props.option.question2.numberMode}
                  formattedNumberMode={this.props.question2.formattedNumberMode}
                  onChange={(e) => this.convertOptionValue2(e.target.value)}
                  required />

                {this.props.itemFootnoteFormatter &&
                  <div className="question-footnote">{this.state.optionValue2}</div>
                }

                {this.props.option.question2.unit ?
                  <input type="hidden"
                    name={`${this.props.option.question2.name}Units`}
                    value={this.props.option.question2.unit} />
                  : null
                }
              </Col>}
            </Row>
          </section>
          :
          <section>
            <input type="hidden" name={this.props.option.question1.name} value="" />
            <input type="hidden" name={this.props.option.question2.name} value="" />
          </section>
        }

        {this.renderFooter()}

      </section>
    )
  }
}

export {
  DoubleQuestion,
  FootnoteFormatter
}



// WEBPACK FOOTER //
// ./src/app/components/questions/double/index.tsx